import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Logout } from '@mui/icons-material';
import TelusLogo from './TelusLogo';

export default function Header({ onLogout }) {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
                RBS Co-Pilot
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <TelusLogo />
                <Button variant="outlined" startIcon={<Logout />} onClick={onLogout} sx={{ textTransform: 'none' }}>
                    Logout
                </Button>
            </Box>
        </Box>
    );
}